<template>
  <gj-modal v-bind="$attrs" v-on="$listeners" :visible.sync="modalVisible"
    :content-style="{ 'height': '100%', 'display': 'flex', 'flex-direction': 'column' }" size="table">
    <template #header>操作日志</template>
    <template #content>
      <div style="flex: 1; overflow: auto">
        <gj-table :columns="columns" adaptParent :data="data" :offset-to="'parent'" :offset-height="21"
          :loading="loading" :pagination="pagination" @sort-change="$gjSortChange" @page-change="$gjNoticeQuery">
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, queryMixin } from "../../../../../minxins";
import { getEmailLogPageList } from "../../../../../api/crm";

export default {
  name: "off-site-mailbox-log",
  mixins: [modalMixIn, queryMixin],
  props: {
    id: null,
  },
  data() {
    return {
      columns: [
        { id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '150px', default: true, sortable: true, },
        { id: 'userName', header: '操作用户', field: 'userName', minWidth: '150px', default: true },
        { id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '150px', default: true },
      ],
      data: [],
      opType: null,
    }
  },
  methods: {
    $gjQuery() {
      this.loading = true;
      getEmailLogPageList({
        model: {},
        ...this.queryPagination,
        ...this.querySort
      }).complete(() => this.loading = false)
        .then((data) => {
          this.data = data.records;
          this.pagination = this.getPagination(data);
        })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .gj-radio-group {
  margin-bottom: 12px;

}
</style>
